import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { showCustomToast } from "./CustomToast";
import { Button, CircularProgress } from "@mui/material";
import { getAuth } from "firebase/auth";

function MAVideosLinksMobile() {
  const [meditationVideos, setMeditationVideos] = useState([]);
  const [reflectionVideos, setReflectionVideos] = useState([]);
  const [loading, setLoading] = useState(false);

  const [newMeditation, setNewMeditation] = useState({ title: "", url: "" });
  const [newReflection, setNewReflection] = useState({ title: "", url: "" });

  const authWeb = getAuth();

  // Écoute en temps réel
  useEffect(() => {
    const qMeditation = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "meditation"),
      orderBy("createdAt", "asc")
    );
    const unsubMeditation = onSnapshot(qMeditation, (snap) => {
      setMeditationVideos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    const qReflection = query(
      collection(db, "mobileAppVideoLinks"),
      where("category", "==", "reflection"),
      orderBy("createdAt", "asc")
    );
    const unsubReflection = onSnapshot(qReflection, (snap) => {
      setReflectionVideos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    return () => {
      unsubMeditation();
      unsubReflection();
    };
  }, []);

  // Ajout vidéo
  const handleAddVideo = async (category) => {
    try {
      setLoading(true);

      const { title, url } =
        category === "meditation" ? newMeditation : newReflection;

      if (!title.trim() || !url.trim()) {
        showCustomToast("Title and URL required", "error");
        return;
      }

      await addDoc(collection(db, "mobileAppVideoLinks"), {
        title,
        url,
        category,
        createdAt: new Date(),
        createdBy: authWeb.currentUser?.email || "unknown",
      });

      if (category === "meditation") setNewMeditation({ title: "", url: "" });
      else setNewReflection({ title: "", url: "" });

      showCustomToast("Video added ✅", "success");
    } catch (e) {
      console.error(e);
      showCustomToast(`Error adding video: ${e.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteVideo = async (id) => {
    try {
      await deleteDoc(doc(db, "mobileAppVideoLinks", id));
      showCustomToast("Video deleted ✅", "success");
    } catch (e) {
      console.error(e);
      showCustomToast(`Error deleting video: ${e.message}`, "error");
    }
  };

  const renderList = (videos) =>
    videos.map((v) => (
      <div
        key={v.id}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #ddd",
          padding: "6px 0",
        }}
      >
        <span style={{ fontWeight: 600 }}>{v.title}</span>
        <span style={{ color: "#555" }}>{v.url}</span>
        <Button
          variant="outlined"
          color="error"
          size="small"
          onClick={() => handleDeleteVideo(v.id)}
        >
          Delete
        </Button>
      </div>
    ));

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        marginTop: "20px",
      }}
    >
      <h2>Manage Meditation & Reflection Videos</h2>

      {/* Meditation */}
      <h3>Meditation videos</h3>
      {renderList(meditationVideos)}
      <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
        <input
          type="text"
          placeholder="Title"
          value={newMeditation.title}
          onChange={(e) =>
            setNewMeditation({ ...newMeditation, title: e.target.value })
          }
        />
        <input
          type="url"
          placeholder="YouTube URL"
          value={newMeditation.url}
          onChange={(e) =>
            setNewMeditation({ ...newMeditation, url: e.target.value })
          }
        />
        <Button
          variant="contained"
          onClick={() => handleAddVideo("meditation")}
          disabled={loading}
        >
          {loading ? <CircularProgress size={18} /> : "Add"}
        </Button>
      </div>

      {/* Reflection */}
      <h3 style={{ marginTop: 20 }}>Reflection videos</h3>
      {renderList(reflectionVideos)}
      <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
        <input
          type="text"
          placeholder="Title"
          value={newReflection.title}
          onChange={(e) =>
            setNewReflection({ ...newReflection, title: e.target.value })
          }
        />
        <input
          type="url"
          placeholder="YouTube URL"
          value={newReflection.url}
          onChange={(e) =>
            setNewReflection({ ...newReflection, url: e.target.value })
          }
        />
        <Button
          variant="contained"
          onClick={() => handleAddVideo("reflection")}
          disabled={loading}
        >
          {loading ? <CircularProgress size={18} /> : "Add"}
        </Button>
      </div>
    </div>
  );
}

export default MAVideosLinksMobile;
